export default __webpack_public_path__ + "static/media/employer_statement.5d717571.png";